/* eslint-disable default-case */
import * as React from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Toolbar, ExcelExport, PdfExport, DetailRow, CommandColumn, Filter, Edit, Inject, Group, Sort, Page, ColumnChooser } from '@syncfusion/ej2-react-grids';
import { SampleBase } from './sample-base';
import * as CustomJS from '../Custom';
import _ from 'underscore/underscore-min';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BlockUi from '@availity/block-ui';
import { random, isUndefined } from 'underscore';
import LavoriInCorso from '../assets/LavoriInCorso2.jpg';


function headerTemplate(props) {    
    return (<div>
         <span style={{ fontSize: '0.9vw', fontWeight: 'bolder' }}>{props.headerText}</span>
    </div>);
}

function fieldTemplate(props) {
    if (props.column.field === 'NumSinistriTotali' && (props.NominativoPerito || '').indexOf('TOTALI') > -1)
        return <div></div>;

    const colore = props.column.field === 'NominativoPerito' ? '#133B95' : 'purple';
    const splitFields = ['NumSinistriTotali', 'DiCuiProperty', 'DiCuiRC', 'DiCuiATP_CTP'];
    const value = props[props.column.field];

    if (splitFields.indexOf(props.column.field) > -1
        && typeof value === 'string'
        && value.indexOf('(') > -1) {
        return (
            <div>
                <span style={{ fontSize: '1.05vw', color: colore, fontWeight: 'bold' }}>
                    {value.substring(0, value.indexOf('(')).trim()}
                </span>
                <br/>
                <span style={{ fontSize: '0.8vw', color: colore, fontWeight: 'bold' }}>
                    {value.substring(value.indexOf('('))}
                </span>
            </div>
        );
    }

    return (
        <div>
            <span style={{ fontSize: '1.0vw', color: colore, fontWeight: 'bold' }}>{value}</span>
        </div>
    );
}

export default class GridPeritiSinistriComplessi extends SampleBase {
    constructor() {
        super(...arguments);  
        this.toggleBlocking = this.toggleBlocking.bind(this);
        this.toolbarOptions = ['ExcelExport', 'Search'];        
        this.pageSettings = { pageCount: 5, pageSize: 15, pageSizes: ['15', '50', 'Tutti'] };   
    }    
    state = {
        blocking: false
    }
    toggleBlocking() {
        this.setState({blocking: !this.state.blocking});
    }
    onQueryCellInfo(args) { 
        if (args.column.field === 'Differenza') {
            args.cell.style.color = 'purple';
            args.cell.style.fontSize = '1.1vw';
            args.cell.style.fontWeight = 'bold';
        }
        if (args.column.field === 'Differenza' && args.data.PercDifferenza < -15 && args.data.Differenza !== '0') {
            args.cell.style.color = 'whitesmoke';
            args.cell.bgColor = '#00802B';
        }  
        else if (args.column.field === 'Differenza' && args.data.PercDifferenza < -5 && args.data.Differenza !== '0') {            
            args.cell.bgColor = '#4DFF4D';
        }  
        else if (args.column.field === 'Differenza' && args.data.PercDifferenza < 5 && args.data.Differenza !== '0') {            
            args.cell.bgColor = 'yellow';
        }  
        else if (args.column.field === 'Differenza' && args.data.PercDifferenza <= 15 && args.data.Differenza !== '0') {  
            args.cell.bgColor = '#FF9900';
        }  
        else if (args.column.field === 'Differenza' && args.data.PercDifferenza > 15 && args.data.Differenza !== '0') {           
            args.cell.style.color = 'whitesmoke';            
            args.cell.bgColor = '#B30000';
        }  
    }    
    onDatabound(args) {       
        for (let ind=0;ind<=10;ind++)
             document.getElementById('GridPeritiSinistriComplessi').querySelectorAll('.e-columnheader')[0].children[ind].style.backgroundColor = 'Linen';
    }
    onRowDatabound(args) {  
        if (args.data.NominativoPerito.indexOf('TOTALI') > -1) {
            args.row.className = 'e-row';
            args.row.bgColor = 'lightpink'; 
        }
    }
    toolbarClick(args) {
        switch (args.item.properties.prefixIcon) {
            case 'e-pdfexport':
                this.gridInstance.pdfExport();
                break;
            case 'e-excelexport':
                this.gridInstance.excelExport();
                break;
        }
    }

    render() {
        return (<React.Fragment>
                    {/* <img src={LavoriInCorso} alt='' width='70%' height='auto'/>  */}
                    <BlockUi tag='div' id='blockUI1' blocking={this.state.blocking} keepInView={true} loader={CustomJS.loaderSpinners[random(CustomJS.loaderSpinners.length - 1)]}>
                        <GridComponent id="GridPeritiSinistriComplessi" ref={grid => this.gridInstance = grid} toolbar={this.toolbarOptions} allowSelection={false} enableHover={false} allowTextWrap={true} height='68vh'
                                allowPaging={false} allowSorting={false} allowFiltering={false} allowExcelExport={true} allowPdfExport={true} queryCellInfo={this.onQueryCellInfo.bind(this)} pageSettings={this.pageSettings}
                                dataBound={this.onDatabound} rowDataBound={this.onRowDatabound.bind(this)} toolbarClick={this.toolbarClick.bind(this)} enableAltRow={true} gridLines='Both'>
                            <ColumnsDirective>                            
                                <ColumnDirective field='NominativoPerito' headerText='Perito' width='15%' headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center' filter={this.Filter} clipMode="EllipsisWithTooltip"></ColumnDirective>
                                <ColumnDirective field='NumSinistriTotali' headerText="Sinistri Totali Aperti" width='11%' headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='NumSinistriComplessi' headerText="Sinistri Complessi Aperti" width='8%' headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='DiCuiProperty' headerText="Di Cui Property (Media Sinistri Aperti/Media Sinistri Restituiti)" headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='DiCuiRC' headerText="Di Cui RC (Media Sinistri Aperti/Media Sinistri Restituiti)" headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='DiCuiATP_CTP' headerText="Di Cui ATP/CTP (Media Sinistri Aperti/Media Sinistri Restituiti)" headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='NumSinistriComplessiApertiMeseCorrente' width='8%' headerText="Sinistri Complessi Aperti Mese Corrente" headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='NumSinistriComplessiChiusiMeseCorrente' width='10%' headerText="Sinistri Complessi Chiusi Mese Corrente" headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='MediaGiorniSinistriAperti' headerText='Media Sinistri Aperti (giorni)' visible={false} headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='MediaGiorniSinistriRestituiti' headerText='Media Sinistri Restituiti (giorni)' visible={false} headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                                <ColumnDirective field='NumSinChiusiAnnoCorr' headerText="Sinistri Chiusi Anno Corrente" width='8%' headerTemplate={headerTemplate} template={fieldTemplate} textAlign='Center'></ColumnDirective>
                            </ColumnsDirective>   
                            <Inject services={[Toolbar, ExcelExport, PdfExport, Filter, Sort, Page]}/>                    
                        </GridComponent> 
                    </BlockUi>                                   
            </React.Fragment>);
    }  
    componentDidMount() {  
        this.caricaDati();  
    } 
    caricaDati(){
        let GridData = [];
        this.toggleBlocking();
        CustomJS.callAPI(`${CustomJS.APIMonitorURLProd}/api/Monitor/portingTutteAPI/peritiSinistriComplessi/[NO]/[NO]/[NO]/[NO]/[NO]/[NO]`, '', 'GET', '', retData => {
            this.toggleBlocking();
            const fmtMedia = (v) => (v === null || v === undefined || v === '')
                ? '0,00'
                : Number(v).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            retData.forEach((elm, idx) => {
                elm.NumSinistriComplessi = elm.NumSinistriComplessi?.toLocaleString() ?? '0';
                elm.NumSinistriTotali = `${elm.NumSinistriTotali?.toLocaleString() ?? '0'} (S=${elm.DiCuiSemplici.toString()}, I=${elm.DiCuiIntermedi.toString()}, 
                                                C=${elm.DiCuiComplessiAperti.toString()})`;
                elm.NumSinistriComplessiApertiMeseCorrente = elm.NumSinistriComplessiApertiMeseCorrente?.toLocaleString() ?? '0';
                elm.NumSinistriComplessiChiusiMeseCorrente = elm.NumSinistriComplessiChiusiMeseCorrente?.toLocaleString() ?? '0';
                elm.DiCuiProperty = `${elm.DiCuiProperty?.toLocaleString() ?? '0'} (${fmtMedia(elm.MediaGiorniSinistriApertiProperty)}/${fmtMedia(elm.MediaGiorniSinistriRestituitiProperty)})`;
                elm.DiCuiRC       = `${elm.DiCuiRC?.toLocaleString() ?? '0'} (${fmtMedia(elm.MediaGiorniSinistriApertiRC)}/${fmtMedia(elm.MediaGiorniSinistriRestituitiRC)})`;
                elm.DiCuiATP_CTP  = `${elm.DiCuiATP_CTP?.toLocaleString() ?? '0'} (${fmtMedia(elm.MediaGiorniSinistriApertiATP_CTP)}/${fmtMedia(elm.MediaGiorniSinistriRestituitiATP_CTP)})`;
                elm.MediaGiorniSinistriApertiNum = elm.MediaGiorniSinistriAperti;
                elm.MediaGiorniSinistriAperti = elm.MediaGiorniSinistriAperti?.toLocaleString() ?? '0,00';
                elm.MediaGiorniSinistriRestituiti = elm.MediaGiorniSinistriRestituiti?.toLocaleString() ?? '0,00';
                elm.NumSinChiusiAnnoCorr = elm.NumSinChiusiAnnoCorr?.toLocaleString() ?? '0';
                GridData.push(elm);
            });
            GridData = _.sortBy(GridData, 'NominativoPerito');  
            let elmTotale = _.find(GridData, (elm) => { return elm.NominativoPerito === 'TOTALI'; });
            GridData = _.filter(GridData, (elm) => { return elm.NominativoPerito !== 'TOTALI'; });
            GridData.unshift(elmTotale); 
            GridData.push(elmTotale);   
            this.gridInstance.dataSource = GridData;   
        }, error => {
            const messaggio = (_.isString(error) && error.indexOf("Not Found")) > -1
                ? CustomJS.messaggioAPIBackendNonTrovata
                : CustomJS.messaggioNoBackend;
            toast.warn(messaggio, {
                containerId: "toastContainer1",
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                newestOnTop: true,
                rtl: false,
                pauseOnFocusLoss: true
            });
            this.toggleBlocking();
        }, true, false);
    }
}